import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value"]
const _hoisted_2 = ["value"]


export default /*@__PURE__*/_defineComponent({
  __name: 'DayInfo',
  props: ['value', 'threshold', 'classa'],
  setup(__props) {


const props = __props


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createElementVNode("input", {
        type: "number",
        disabled: "",
        value: props.value.sum,
        step: "0.5",
        class: _normalizeClass({
                'above-8': props.value.sum > props.threshold, 'below-8': props.value.sum < props.threshold,
                'small-22': props.classa == 0, 'wider-22': props.classa == 1
            })
      }, null, 10, _hoisted_1)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("input", {
        type: "number",
        disabled: "",
        value: props.value.ot,
        step: "0.5",
        class: _normalizeClass({
                'small-22': props.classa == 0, 'wider-22': props.classa == 1
            })
      }, null, 10, _hoisted_2)
    ])
  ]))
}
}

})